<div class="dashboard-page">
  <header class="dashboard-header">
    <h1>Analytics Portal</h1>
    <p class="dashboard-subtitle">Select a report to view live data</p>
  </header>

  <div *ngIf="errorMessage" class="dashboard-error" role="alert">
    <p>{{ errorMessage }}</p>
    <button type="button" (click)="retry()">Retry</button>
  </div>

  <div *ngIf="loading" class="dashboard-loading">Loading reports...</div>

  <div *ngIf="!loading && !errorMessage" class="dashboard-grid">
    <article
      *ngFor="let report of reports; let i = index"
      class="report-card"
      (click)="openReport(report.id)"
    >
      <h2 class="report-card__title">{{ report.name }}</h2>

      <div class="report-card__preview" [attr.data-variant]="previewVariant(i)">
        <div *ngIf="previewVariant(i) === 0" class="preview-grid">
          <span
            *ngFor="let cell of gridCells"
            [class]="'cell cell--' + (cell % 4)"
          ></span>
        </div>

        <div *ngIf="previewVariant(i) === 1" class="preview-bars">
          <span
            *ngFor="let bar of barHeights"
            class="bar"
            [style.height.%]="bar"
          ></span>
        </div>

        <div *ngIf="previewVariant(i) === 2" class="preview-line">
          <svg viewBox="0 0 200 80" preserveAspectRatio="none">
            <polyline points="0,60 30,45 60,50 90,25 120,35 150,15 180,30 200,10" />
          </svg>
          <div class="preview-donut"></div>
        </div>

        <div *ngIf="previewVariant(i) === 3" class="preview-status">
          <span class="status-bar"></span>
          <div class="status-dots">
            <span *ngFor="let dot of statusDots"></span>
          </div>
        </div>
      </div>

      <div class="report-card__actions">
        <button
          type="button"
          class="btn btn--primary"
          (click)="openReport(report.id); $event.stopPropagation()"
        >
          Live
        </button>
      </div>
    </article>
  </div>
</div>
